import { render, staticRenderFns } from "./TableText.vue?vue&type=template&id=3e327947&scoped=true"
import script from "./TableText.vue?vue&type=script&lang=js"
export * from "./TableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e327947",
  null
  
)

export default component.exports